(function(app) {
    app.constant("physicalAddressTypes",
    [
        "Residence",
        "Business",
        "Vacation",
        "Other"
    ]);
})(window.app); //jshint ignore:line